import {createElement} from 'react'
import {addMaybeClassName} from '@freckle/educator-entities/ts/common/helpers/classnames'
import {innerHTMLText} from '@freckle/educator-entities/ts/common/models/html-text'
import type {HeadingProps} from '@freckle/educator-materials/ts/components/typography/heading-props'
import {h2} from './typography.module.scss'

type Props = HeadingProps

export function H2(props: Props) {
  const {children, className, dataTest, id} = props
  const newClassName = addMaybeClassName(h2, className)
  const dataTestObj = dataTest !== null && dataTest !== undefined ? {'data-test': dataTest} : {}
  const idObj = id !== null && id !== undefined ? {id} : {}
  const tagToUse = props.as ?? 'h2'
  const node = createElement(
    tagToUse,
    {
      className: newClassName,
      ...dataTestObj,
      ...idObj,
      ...(props.innerHTMLText !== undefined ? innerHTMLText(props.innerHTMLText) : {})
    },
    children
  )
  return node
}
